const JavelinaBaseClient = require("./JavelinaBaseClient");

class JavelinaProviderClient extends JavelinaBaseClient {
    constructor(
        javelinaProxyApiUrl = process.env.JAVELINA_PROXY_API_URL, 
        javelinaProxySecretName = process.env.JAVELINA_PROXY_SECRET_NAME || '',
        axiosOptions
    ) {
        super(javelinaProxyApiUrl, javelinaProxySecretName, axiosOptions)
    }

    /**
     * @description returns care points by Javelina facility id
     * @param {String} id JV Facility ID 
     */
    async listProviderAffiliationsByFacilityID(id) {
        await this.createSecureAxiosInstance()

        const params = {
            FacilityID: id
        }

        let path = this.queryParamsToPathParams(params, `pureProxy/provider/listprovideraffiliations`);

        const response = await this.secureAxiosInstance.get(path);

        if (response.status !== 200) {
            return null;
        }

        return response.data;
    }

    /**
     * @description returns provider info by NPI
     * @param {String} npi npi of the provider
     */
    async searchPhysiciansByNationalProviderID(npi) {
        await this.createSecureAxiosInstance()

        const params = {
            NationalProviderID: npi
        }

        let path = this.queryParamsToPathParams(params, `pureProxy/provider/searchPhysicians`);

        const response = await this.secureAxiosInstance.get(path);

        if (response.status !== 200) {
            return null;
        }

        return response.data;
    }

    /**
     * @description returns detailed provider info by Javelina Physican Id
     * @param {String} id JV Physican ID 
     */
    async getPhysicianByPhysicanID(id) {
        await this.createSecureAxiosInstance()

        const params = {
            PhysicianID: id
        }

        let path = this.queryParamsToPathParams(params, `pureProxy/physicians`);

        const response = await this.secureAxiosInstance.get(path);

        if (response.status !== 200) {
            return null;
        }

        return response.data;
    }

    /**
     * @description returns care points by Javelina physican id
     * @param {String} id JV Physican ID 
     */
    async listProviderAffiliationsByPhysicianID(id) {
        await this.createSecureAxiosInstance()

        const params = {
            PhysicianID: id
        }

        let path = this.queryParamsToPathParams(params, `pureProxy/provider/listprovideraffiliations`);

        const response = await this.secureAxiosInstance.get(path);

        if (response.status !== 200) {
            return null;
        }

        return response.data;
    }
}

module.exports = JavelinaProviderClient